import { EbCategorie } from './../classes/categorie';
import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions, Response } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import { EbUser } from "../classes/user";
import { EbEtablissement } from "../classes/etablissement";
import { EbCompagnie } from "../classes/compagnie";
import { EbAdresse } from "../classes/adresse";
import { SearchCriteria } from "../utils/searchCriteria";
import { EbCostCenter } from "../classes/costCenter";
import { AuthHttp , JwtHelper} from 'angular2-jwt';
import { EbLabel } from '../classes/label';
import { Statique } from "../utils/statique";
import CustomField from '../classes/customField';
import { EbCompagnieCurrency } from '../classes/compagnieCurrency';

@Injectable()
export class EtablissementService {
 statique = Statique
	constructor(private authHttp:AuthHttp) { }

	getEtablisement(searchCriteria: SearchCriteria) {
		return this.authHttp.post(Statique.controllerEtablissement +  "/get-etablisement", searchCriteria)
			.map((res: Response) => res.json());
	}

	getListEtablisement(searchCriteria: SearchCriteria) {
		return this.authHttp.post(Statique.controllerEtablissement + "/get-list-etablisement", searchCriteria)
			.map((res: Response) => res.json());
	}

	getListEtablisementCt(searchCriteria: SearchCriteria) {
		return this.authHttp.post(Statique.controllerEtablissement + "/getlist-etablisement-ct", searchCriteria)
			.map((res: Response) => res.json());
	}

	getAdresseEtablisement(ebEtablissementNum: number) {
		return this.authHttp.get(Statique.controllerEtablissement + "/get-adresse-etablisement/"+ebEtablissementNum)
			.map((res: Response) => res.json());
	}

	addAdresseEtablisement(ebAdresse: EbAdresse) {
		return this.authHttp.post(Statique.controllerEtablissement + "/add-adresse-etablisement", ebAdresse)
			.map((res: Response) => res.json());
	}

	editAdresseEtablisement(ebAdresse: EbAdresse) {
		return this.authHttp.post(Statique.controllerEtablissement + "/edit-adresse-etablisement", ebAdresse)
			.map((res: Response) => res.json());
	}

	deleteAdresseEtablisement(ebAdresse: EbAdresse) {
		return this.authHttp.post(Statique.controllerEtablissement + "/delete-adresse-etablisement", ebAdresse)
			.map((res: Response) => res.json());
	}

	// -------------------------------------------------------------- //

	getListCostCenterEtablisement(searchCriteria: SearchCriteria) {
		return this.authHttp.post(Statique.controllerEtablissement + "/get-list-cost-center-etablisement", searchCriteria)
			.map((res: Response) => res.json());
	}

	addCostCenterEtablisement(ebCostCenter: EbCostCenter) {
		return this.authHttp.post(Statique.controllerEtablissement + "/add-cost-center-etablisement", ebCostCenter)
			.map((res: Response) => res.json());
	}

	editCostCenterEtablisement(ebCostCenter: EbCostCenter) {
		return this.authHttp.post(Statique.controllerEtablissement + "/edit-cost-center-etablisement", ebCostCenter)
			.map((res: Response) => res.json());
	}

	deleteCostCenterEtablisement(ebCostCenter: EbCostCenter) {
		return this.authHttp.post(Statique.controllerEtablissement + "/delete-cost-center-etablisement", ebCostCenter)
			.map((res: Response) => res.json());
	}

	// -------------------------------------------------------------- //

	addCategorie(ebCategorie: EbCategorie){
		return this.authHttp.post(Statique.controllerCategorie + "/add", ebCategorie)
			.map((res: Response) => res.json());
	}

	deleteCategorie(ebCategorie: EbCategorie) {
		return this.authHttp.post(Statique.controllerCategorie + "/delete", ebCategorie)
			.map((res: Response) => res.json());
	}

	addLabel(ebLabel: EbLabel){
		return this.authHttp.post(Statique.controllerCategorie + "/label/add", ebLabel)
			.map((res: Response) => res.json());
	}

	deleteLabel(ebLabel: EbLabel){
		return this.authHttp.post(Statique.controllerCategorie + "/label/delete", ebLabel)
			.map((res: Response) => res.json());
	}

	// -------------------------------------------------------------- //
	
	saveCustomField(customField: CustomField){
		return this.authHttp.post(Statique.controllerEtablissement + "/add-customfield", customField)
			.map((res: Response) => res.json());
	}
	
	getCustomFields(ebCompagnieNum: number){
		return this.authHttp.post(Statique.controllerEtablissement + "/get-customfield", {ebCompagnieNum})
			.map((res: Response) => res.json());
	}

	// -------------------------------------------------------------- //

	saveExEtablissementCurrency(exEtablissementCurrency: EbCompagnieCurrency){
		return this.authHttp.post(Statique.controllerEtablissement + "/save-exEtablissementCurrency", exEtablissementCurrency)
			.map((res: Response) => res.json());
	}

	deleteExEtablissementCurrency(exEtablissementCurrency: EbCompagnieCurrency){
		return this.authHttp.post(Statique.controllerEtablissement + "/delete-exEtablissementCurrency", exEtablissementCurrency)
			.map((res: Response) => res.json());
	}
	
	getListExEtablissementCurrency(searchCriteria: SearchCriteria){
		return this.authHttp.post(Statique.controllerEtablissement + "/get-list-exEtablissementCurrency", searchCriteria)
			.map((res: Response) => res.json());
	}
	
	getExEtablissementCurrencyActive(ebEtablissementNum: number){
		return this.authHttp.post(Statique.controllerEtablissement + "/get-exEtablissementCurrencyActive", ebEtablissementNum)
			.map((res: Response) => res.json());
	}

	getDataPreference(criteria: SearchCriteria){
		return this.authHttp.post(Statique.controllerEtablissement + "/get-data-preference", criteria)
			.map((res: Response) => res.json());
	}

	getListExEtablissementCategories(ebEtablissementNum: number){
		return this.authHttp.post(Statique.controllerEtablissement + "/get-listCategories", {ebEtablissementNum})
			.map((res: Response) => res.json());
	}

	getListExEtablissementCurrencyforQuotation(searchCriteria: SearchCriteria){
		return this.authHttp.post(Statique.controllerEtablissement + "/get-list-exEtablissementCurrency-forquotation", searchCriteria)
			.map((res: Response) => res.json());
	}


	getEtablissementAgences(ebEtablissementNum : number){
		return this.authHttp.get(Statique.controllerEtablissement + "/get-list-agences-etablissement/"+ebEtablissementNum)
		.map((res: Response) => res.json());
	}

	updateEtablissementAgence(ebEtablissement : EbEtablissement){
		return this.authHttp.post(Statique.controllerEtablissement + "/update-etablissement-agence", ebEtablissement)
		.map((res: Response) => res.json());
	}

	getListAgenceByEtablissementAndType(ebEtablissementNum : number, agenceType : string){
		return this.authHttp.post(Statique.controllerEtablissement + "/get-list-agences-etablissement-byType/"+ebEtablissementNum, agenceType)
		.map((res: Response) => res.json());
	}

	deleteEtablissement(ebEtablissement : EbEtablissement){
		return this.authHttp.post(Statique.controllerEtablissement + "/delete-etablissement", ebEtablissement)
		.map((res: Response) => res.json());
	}
}



// WEBPACK FOOTER //
// ./src/app/services/etablissement.service.ts